import React from 'react';
import styled from 'styled-components';
import { Body5, Container, H5 } from '@ui';
import { ResultOnly } from '@containers/DigitalAnalyst/components/AnswerLine';
import { ROUTES } from '@constants/routes';
import { SkeletonButton } from '@ui/buttons/SkeletonButton';

const Wrapper = styled.div`
  padding: 16px 0 0 0;
`;
const RowValues = styled.div`
  margin-top: 24px;

  width: 100%;
`;

const RowValue = ({ keyName, templateKey, answers }) => {
  const answerValue = answers[templateKey] || 'Working...';

  return (
    <Container>
      <Body5 bold>{keyName}</Body5>
      <Container left={16}>{templateKey ? <ResultOnly result={answerValue} /> : null}</Container>
    </Container>
  );
};

const TextAnswer = ({ answers, templateKey }) => {
  const answerValue = answers[templateKey] || 'Working...';
  return <ResultOnly result={answerValue} />;
};

export const QuickLook = ({ answers, selectedDocs }) => {
  if (!answers) {
    return null;
  }

  const onQueryDocumentsClick = () => {
    const url = ROUTES.digitalAnalyst + `?doc-ids=${selectedDocs.map((d) => d.id).join(',')}`;
    window.open(url, '_blank');
  };

  return (
    <Wrapper>
      <Container row verticallyCenter spaceBetween bottom={24}>
        <H5>
          <TextAnswer answers={answers} templateKey={'{{TEMPLATE_1}}'} />
        </H5>
        <Container left={8}>
          <SkeletonButton onClick={onQueryDocumentsClick}>Query Documents</SkeletonButton>
        </Container>
      </Container>
      <Container>
        <RowValue keyName={'Overview'} answers={answers} templateKey={'{{TEMPLATE_2}}'} />
        <RowValue keyName={'Revenue Generators'} answers={answers} templateKey={'{{TEMPLATE_3}}'} />
        <RowValue keyName={'Target Markets and Revenue'} answers={answers} templateKey={'{{TEMPLATE_4}}'} />
        <RowValue keyName={'Competitors'} answers={answers} templateKey={'{{TEMPLATE_5}}'} />
        <RowValue keyName={'Differentiators'} answers={answers} templateKey={'{{TEMPLATE_6}}'} />
        <RowValue keyName={'Recent Results'} answers={answers} templateKey={'{{TEMPLATE_7}}'} />
        <RowValue keyName={'Growth Strategy'} answers={answers} templateKey={'{{TEMPLATE_8}}'} />
        <RowValue keyName={'Targets'} answers={answers} templateKey={'{{TEMPLATE_9}}'} />
      </Container>

      <Container top={16}>
        <H5 uppercase bold>
          Summary Bull Cases
        </H5>
        <Container top={16}>
          <RowValue keyName={'Executive Summary:'} answers={answers} templateKey={'{{TEMPLATE_10}}'} />
          <RowValue keyName={'Summary Bull Case:'} answers={answers} templateKey={'{{TEMPLATE_11}}'} />
          <RowValue keyName={'“Heart” of Bull Case Thesis:'} answers={answers} templateKey={'{{TEMPLATE_12}}'} />
          <RowValue keyName={'Market Share/Pricing:'} answers={answers} templateKey={'{{TEMPLATE_13}}'} />
          <RowValue keyName={'Potential AI-Benefits:'} answers={answers} templateKey={'{{TEMPLATE_14}}'} />
          <RowValue keyName={'Growth/Profit Drivers:'} answers={answers} templateKey={'{{TEMPLATE_15}}'} />
          <RowValue keyName={'Potential Bullish Catalysts:'} answers={answers} templateKey={'{{TEMPLATE_16}}'} />
          <RowValue keyName={'1Q25 Update - Evercore ISI'} answers={answers} templateKey={'{{TEMPLATE_17}}'} />
          <RowValue keyName={'Valuation'} answers={answers} templateKey={'{{TEMPLATE_18}}'} />
        </Container>
      </Container>

      <Container top={36}>
        <H5 uppercase bold>
          Summary Bear Cases
        </H5>
        <Container top={16}>
          <RowValue keyName={'Executive Summary:'} answers={answers} templateKey={'{{TEMPLATE_19}}'} />
          <RowValue keyName={'Summary Bear Case:'} answers={answers} templateKey={'{{TEMPLATE_20}}'} />
          <RowValue keyName={'“Heart” of Bear Case:'} answers={answers} templateKey={'{{TEMPLATE_21}}'} />
          <RowValue keyName={'Competition/Pricing:'} answers={answers} templateKey={'{{TEMPLATE_22}}'} />
          <RowValue keyName={'Potential AI-Risks:'} answers={answers} templateKey={'{{TEMPLATE_23}}'} />
          <RowValue keyName={'Risk to Fundamentals'} answers={answers} templateKey={'{{TEMPLATE_24}}'} />
          <RowValue keyName={'Need to Believe the Math:'} answers={answers} templateKey={'{{TEMPLATE_25}}'} />
          <RowValue keyName={'Valuation'} answers={answers} templateKey={'{{TEMPLATE_26}}'} />
        </Container>
      </Container>
    </Wrapper>
  );
};
